import script from "./PerioGardTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./PerioGardTwo.vue?vue&type=script&setup=true&lang=js"

import "./PerioGardTwo.vue?vue&type=style&index=0&id=2448845b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2448845b"]])

export default __exports__